/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { ValidateCounty, ValidateCountyApiParameter } from "@eisinc/App/Services/ValidateCountyService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<
    ValidateCountyApiParameter & { onSuccess?: (response: any) => void; onError?: (error: any) => void },
    any
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    try {
        props.apiResult = await ValidateCounty(props.apiParameter);
        props.parameter.onSuccess?.(props.apiResult);
    } catch (error) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, SendDataToApi];

const validateCounty = createHandlerChainRunner(chain, "ValidateCounty");
export default validateCounty;
